import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './drawerContent.module.css';

const styles = {
  icon: {
    fontSize: '5.5rem',
    width: '5.5rem',
    height: '5.5rem',
    marginTop: '7.5rem',
    marginBottom: '1rem',
  },
};

interface Props {
  icon: string;
  text: string;
  subtext: string;
}

const NoItemsPane = ({ icon, text, subtext }: Props) => {
  return (
    <div className={classes.noItemsContainerV2}>
      <Icon style={styles.icon} color={colors.neutral.gray}>
        {icon}
      </Icon>
      <p className={classes.noItemsTextV2}>{text}</p>
      <p className={classes.noItemsSubtextV2}>{subtext}</p>
    </div>
  );
};

export default NoItemsPane;
